export default __webpack_public_path__ + "static/media/43.576a90c5.jpg";